import { useCallback } from 'react';
import { ICardInfo, ICardItem } from '@/types';
import { useCommonParams, useLoading } from '@/hooks';
import { clickEventHandler } from '@/helpers';
import { IntersectionObserver } from '@/components/common';
import { CreditListItem } from '@/components/organisms';
import { Wrapper } from '@/components/templates/collectCardList/CollectCardList.styled';
import { COMPONENT_TYPE } from '@/const';
import { useRouter } from 'next/router';

export const CollectCardList = (props: ICardInfo) => {
  const { ads = [] } = props;
  const commonParams = useCommonParams();
  const [, setLoading] = useLoading();

  const router = useRouter();
  const { ref_event_id } = router.query;

  const handleClick = useCallback(
    async (item: ICardItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,
        componentName: COMPONENT_TYPE.CARD,
      });
    },
    [commonParams, setLoading],
  );

  const renderComponent = (item: ICardItem, index: number) => (
    <IntersectionObserver key={index} {...item} page={commonParams.page} refEventId={ref_event_id ? ref_event_id as string : ''} componentName={COMPONENT_TYPE.CARD}>
      <CreditListItem {...item} onClick={() => handleClick(item)} />
    </IntersectionObserver>
  );
  return (
    <Wrapper>
      {ads.length > 0 && ads.map((item: ICardItem, index: number) => renderComponent(item, index))}
    </Wrapper>
  );
};

export default CollectCardList;
